<template>
	<div>
		<transition>
			<b-container fluid>
				<b-form @submit.stop.prevent="onSubmit" class="mt-10">
					<!-- ================ otp Code ============ -->
					<b-row align-h="center" class="pt-5">
						<b-col md="9" cols="9">
							<b-form-group
								id="otp_group"
								:label="$t('register.otp')"
								label-for="otp"
							>
								<b-form-input
									id="otp"
									type="number"
									v-model="$v.form.token.$model"
									:state="validateState('token')"
									:placeholder="$t('placehoders.otp')"
								>
								</b-form-input>
								<small class="text-color--400  mt-2 mt-sm-0 ">
									<center>
										<a
											role="button"
											type="button"
											:disabled="counting"
											@click="startCountdown"
										>
											<countdown
												v-if="counting"
												:time="120000"
												@end="handleCountdownEnd"
												class="text-color--400 font-size--10 mt-2 mt-sm-0 text-center"
											>
												<template slot-scope="props">
													ارسال دوباره کد بعد از
													{{ props.totalSeconds }} ثانیه
												</template>
											</countdown>
											<span
												class="text-color--400 font-size--10 mt-2 mt-sm-0 text-center"
												v-else
												><a class="btn" role="button" @click="resentOtp">
													{{ $t("register.otppage.resendCode") }}</a
												></span
											>
										</a>
									</center>
								</small>
								<b-form-invalid-feedback id="otp-live-feedback">
									{{ $t("validation.required") }}
								</b-form-invalid-feedback>
								
							</b-form-group>
						</b-col>
					</b-row>

					<b-row align-h="center" class="justify-content-center">
						<b-col cols="9">
							<div>
								<b-button
									type="submit"
									size="md"
									class="btn btn-hover--3d btn-left btn-bg--primary"
									>{{ $t("register.save") }}
								</b-button>
							</div>
						</b-col>
					</b-row>
				</b-form>
				<b-row align-h="center" class="mb-5 pb-5">
					<b-col md="8" cols="9">
						<hr />
						<b-link to="/register">
							<small class="text-color--400 ">
								{{ $t("register.incorrectMobile") }}
							</small>
						</b-link>
					</b-col></b-row
				>
			</b-container>
		</transition>
	</div>
</template>

<script>
import Vue from "vue";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import Countdown from "@chenfengyuan/vue-countdown";



import { required } from "vuelidate/lib/validators";

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
export default {
	mounted()
	{
		// console.log("--------------------------isSupplier: "+this.$route.params)
		// console.log("--------------------------isSupplier: "+JSON.stringify(this.$route.params))
		//console.log("--------------------------isSupplier: "+JSON.stringify(this.$route))


		if(this.$route.params["isSupplier"])
		{
			this.isSupplier = true
		}
	},
	data() {
		return {
			isSupplier:false,
			form: {
				token: "",
				mobile_number: this.$store.getters.getMobileNumber,
			},
			counting: true,
		};
	},
	validations: {
		form: {
			token: {
				required,
			},
		},
	},
	methods: {
		onSubmit() {
			this.$v.$touch();
			if (this.$v.$invalid) {
				this.submitStatus = "ERROR";
				this.$noty.info(this.$t("alert.alertInvalidField"));
			} else {
				let load = this.$loading.show();
				
				this.$store
					.dispatch("checkOtp", this.form)
					.then((response) => {
						console.log(response);
						load.hide();
						if(this.isSupplier)
						{
							localStorage.setItem("SupplierCustomerId",1)
							// localStorage.setItem("SupplierCustomerId",response.body.id)
							// localStorage.setItem("SupplierCustomerMelliCode",this.$store.getters.getCustomer.melli_code)
							this.$router.push({ name: "identitiy" });
						}
						else
						{
							localStorage.removeItem("SupplierCustomerId")
							this.$router.push({name:"identitiy"})
							//this.$router.push({ name: "registerPage" });
						}
			// 			this.$store
			// 		.dispatch("creatCustomer", this.$store.getters.getCustomer)
			// 		.then((response) => {
			// 			console.log(response);
			// 			load.hide();
			// 			// let loginForm = {
			// 			// 	melli_code:this.$store.getters.getCustomer.melli_code,
			// 			// 	mobile_number:this.$store.getters.getCustomer.mobile_number,
			// 			// 	password:this.$store.getters.getCustomer.password
			// 			// }
			// 			if(this.isSupplier)
			// 			{
			// 				localStorage.setItem("SupplierCustomerId",response.body.id)
			// 				localStorage.setItem("SupplierCustomerMelliCode",this.$store.getters.getCustomer.melli_code)
			// 				this.$router.push({ name: "registerPage" });
			// 			}
			// 			else
			// 			{
			// 			// 	this.$store.dispatch("login", loginForm).then(() => {
							
			// 			// 	this.$router.push({ name: "registerPage" });
			// 			// });
			// 			this.$router.push({name:"registerPage"})
			// 			}
						

			// 		})
			// 		.catch((err) => {
			// 			console.log(err);
			// 			this.$noty.error(err.body.error);
			// 			load.hide();
			// 		});
						
			// 		})
			// 		.catch((err) => {
			// 			console.log(err);
			// 			this.$noty.error(err.body.error);
			// 			load.hide();
			// 		});
			// }
					})}},

		resentOtp() {
			this.$store
				.dispatch("resentOtp")
				.then((resp) => {
					console.log(resp);
				})
				.catch((err) => {
					console.log(err);
				});
		},
		startCountdown() {
			this.counting = true;
		},
		handleCountdownEnd() {
			this.counting = false;
		},

		validateState(name) {
			const { $dirty, $error } = this.$v.form[name];
			return $dirty ? !$error : null;
		},
	},
	components: {
		// VueCountdown.name,
		Countdown,
	},
};
</script>

<style scoped>
.btn-left {
	display: block;
	margin: auto;
}
</style>
<style scoped scr="bootstrap/dist/css/bootstrap.css">

</style>
<style scoped scr="bootstrap-vue/dist/bootstrap-vue.csss"></style>